import React from 'react';
import { Container } from 'react-bootstrap';
import { FaGlobeAsia, FaTag, FaWarehouse, FaShieldAlt } from 'react-icons/fa';
import Icon from '../../../components/ui/Icon';
import courier from '../../../assets/images/features-courier.webp';
import { ScrollText, Reveal, Stagger, StaggerItem, ParallaxImage } from '../../../components/motion';
import Eyebrow from '../../../components/ui/Eyebrow';
import styles from './FeaturesSection.module.css';

type Feature = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon: any; // react-icons component, rendered through <Icon>
  title: string;
  description: string;
};

const FEATURES: Feature[] = [
  {
    icon: FaGlobeAsia,
    title: '12 branches, 10 countries',
    description:
      'From Duba to Jizan, shipping to India, Pakistan, the Philippines, the UK and 6 more.',
  },
  {
    icon: FaTag,
    title: 'Transparent pricing',
    description:
      'The price we quote is the price you pay — no hidden charges added later.',
  },
  {
    icon: FaWarehouse,
    title: 'Warehousing & storage',
    description:
      "Secure space in Saudi Arabia to keep your goods until they're ready to ship.",
  },
  {
    icon: FaShieldAlt,
    title: 'Cargo insurance',
    description:
      'Protected from the moment we collect it until it reaches the destination.',
  },
];

const FeaturesSection: React.FC = () => {
  return (
    <section className={styles.features}>
      <Container fluid="xl" className={styles.inner}>
        <div className={styles.grid}>
          <div className={styles.left}>
            <ParallaxImage
              src={courier}
              alt="Sahari Cargo courier holding a delivery box"
              className={styles.image}
              amount={8}
            />
          </div>

          <div className={styles.right}>
            <header className={styles.head}>
              <Eyebrow>Why Sahari Cargo</Eyebrow>
              <ScrollText
                as="h2"
                className={styles.title}
                accentWords={[3, 4]}
                accentClassName={styles.accent}
              >
                Four reasons people trust us with their boxes
              </ScrollText>
              <Reveal as="p" className={styles.subtitle} delay={0.05}>
                From pickup at your door to delivery in your home country — one
                company, one price, no surprises.
              </Reveal>
            </header>

            <Stagger as="ul" className={styles.list} stagger={0.12}>
              {FEATURES.map((feature, i) => (
                <StaggerItem
                  key={feature.title}
                  as="li"
                  direction="up"
                  className={styles.item}
                >
                  <span className={styles.number} aria-hidden="true">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <div className={styles.itemContent}>
                    <h3 className={styles.itemTitle}>{feature.title}</h3>
                    <p className={styles.itemDescription}>
                      {feature.description}
                    </p>
                  </div>
                  <span className={styles.iconWrap} aria-hidden="true">
                    <Icon icon={feature.icon} />
                  </span>
                </StaggerItem>
              ))}
            </Stagger>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default FeaturesSection;
